module.exports = __webpack_public_path__ + "static/img/achieve05.eecf8fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/achieve05.png
// module id = Zwp+
// module chunks = 1